module.exports = __webpack_public_path__ + "media/1_1-42.f94dc0a1.mp3";